import { Methods } from '../communication/methods.js';
//# sourceMappingURL=messaging.js.map